import { PROFILE_ID } from "../profiles/enums";
import { CONFIG_NAME } from "./enums";

export default {
  name: CONFIG_NAME.ARGENTINA,
  profileId: PROFILE_ID.SKY_CL_CHATBOT_ES,
  sdkConfig: {
    lang: "es",
    labels: {
      es: {
        "interface-title": "SKY - Argentina",
        "close-chat":
          "¿Desea cerrar el chat? <p>Se perderá el histórico de la conversación</p>",
      },
    },
    variables: [
      { name: "HM", value: "AR" },
      { name: "HM_LINK_NAME", value: "argentina" },
    ],
    ratingOptions: [
      { id: 1, label: "Sí", comment: false, response: "¡Gracias!" },
      { id: 2, label: "No", comment: true },
    ],
  },
  appConfig: {
    instance: "cl",
    context: "GENERAL",
    salesforceConf: {
      instance: "argentina",
      endpoints: {
        staging: "https://sky-chatbot-sfl-6656-staging.u01.inbenta.services",
        production: "https://sky-chatbot-sfl-6656-prod.u01.inbenta.services",
      },
    },
  },
};
